import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { GoalDetailPage } from '@/components/goals/goal-detail/goal-detail-page';
import { loadNamespaces } from '@/lib/i18n/i18n';

const paramSchema = z.object({ goalId: z.coerce.number().int().positive() });

export const Route = createFileRoute('/_authenticated/goals/$goalId')({
  loader: () => loadNamespaces('goals'),
  staticData: { title: 'route.goal_detail.title' },
  parseParams: (params) => paramSchema.parse(params),
  component: GoalDetailRoute,
});

function GoalDetailRoute(): React.ReactElement {
  const { goalId } = Route.useParams();
  return <GoalDetailPage goalId={goalId} />;
}
